export default "__VITE_ASSET__EIs1TVRC39nrWWZXFP69pw__"